import { render, staticRenderFns } from "./InProcessingClassDetailsComponent.vue?vue&type=template&id=58a482d7&"
import script from "./InProcessingClassDetailsComponent.vue?vue&type=script&lang=ts&"
export * from "./InProcessingClassDetailsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a482d7')) {
      api.createRecord('58a482d7', component.options)
    } else {
      api.reload('58a482d7', component.options)
    }
    module.hot.accept("./InProcessingClassDetailsComponent.vue?vue&type=template&id=58a482d7&", function () {
      api.rerender('58a482d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Course/InProcessingClassDetailsComponent.vue"
export default component.exports